// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Logo_logoContainer__QaZ2t"};